import { Flex, Progress, Box } from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import { useStores } from '../store/rootStore';
import { PageType } from '../utils/pageType';

const ProgressBar: React.FC<{ currentPage: PageType }> = observer(
  ({ currentPage }) => {
    const { pages, lastKnowPageIndex, setLastKnowPageIndex } = useStores();
    const [currentPageNum, setCurrentPageNum] = useState(lastKnowPageIndex);

    useEffect(() => {
      pages.forEach((page, i) => {
        if (page === currentPage) {
          setCurrentPageNum(i);
          setLastKnowPageIndex(i);
        }
      });
    }, [currentPageNum, pages]);

    return (
      <Box width={'100%'} className="noScroll">
        <Flex
          direction={'column'}
          marginTop={'1'}
          marginLeft={'75'}
          marginRight={'75'}
        >
          <Flex direction={'row'} justifyContent={'center'}>
            <Box opacity={0.5} fontSize={15}>
              {currentPageNum} / {pages.length - 1}
            </Box>
          </Flex>
          <Progress
            value={(currentPageNum / (pages.length - 1)) * 100}
            backgroundColor={'#2D3748'}
            width={'100%'}
            size={'sm'}
            rounded={'4'}
            sx={{
              '& > div:first-child': {
                transitionProperty: 'width',
              },
            }}
          />
        </Flex>
      </Box>
    );
  },
);

export default ProgressBar;
